/**
 * @generated SignedSource<<e66ba90b92a903bd288b439265a9d25d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiningPolicySection_booking$data = {
  readonly policy?: string | null | undefined;
  readonly " $fragmentType": "DiningPolicySection_booking";
};
export type DiningPolicySection_booking$key = {
  readonly " $data"?: DiningPolicySection_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiningPolicySection_booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiningPolicySection_booking",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "policy",
          "storageKey": null
        }
      ],
      "type": "DiningBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "fab4200e0a9b7bac53a2d4624891399c";

export default node;
